import { render, staticRenderFns } from "./MultipleAnswer.vue?vue&type=template&id=347c1760&"
import script from "./MultipleAnswer.vue?vue&type=script&lang=js&"
export * from "./MultipleAnswer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports